import { IonButton, IonIcon, IonItem, IonLabel, IonSpinner, IonText } from '@ionic/react';
import { refresh } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { syncTimer } from '../../../common/interval';
import { useDataSync } from '../../../providers/DataSyncProvider';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { setFranchisesHasSyncStoreAsync, setFranchisesSyncLoadingState } from '../../../store/franchiseSyncSlice';
import { IFranchiseSyncStatus } from '../../../models/dms/franchise.model';

interface IComponentProps {
  title: string;
}

let franchisesTime: { timestamp: number; sync?: IFranchiseSyncStatus } = {
  timestamp: 0,
  sync: undefined,
};

const FranchisesSyncItem: React.FC<IComponentProps> = ({ title }) => {
  const { enableOfflineMode } = useAppSelector((state) => state.settings);
  const {
    state: { franchisesSyncTimer },
  } = useDataSync();

  const dispatch = useAppDispatch();

  const [franchiseTimestamp, setFranchiseTimestamp] = useState(0);
  const { franchisesSync, franchisesSyncLoading } = useAppSelector((state) => state.franchiseSync);

  useEffect(() => {
    const syncSub = syncTimer.subject.subscribe((id) => {
      if (id > 0) {
        const now = new Date().getTime();

        // Repair orders
        if (franchisesTime.sync) {
          if (franchisesTime.sync.timestamp <= 0) {
            franchisesTime.timestamp = -1;
          } else {
            const timeDiff = now - franchisesTime.sync.timestamp;
            franchisesTime.timestamp = Math.floor(timeDiff / 60000);
            setFranchiseTimestamp(franchisesTime.timestamp);
          }
        }
      }
    });

    return () => syncSub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    franchisesTime.sync = franchisesSync;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [franchisesSync]);

  const handleRefreshButtonClick = () => {
    dispatch(setFranchisesSyncLoadingState(true));
    dispatch(setFranchisesHasSyncStoreAsync(false));
    franchisesSyncTimer?.fire();
  };

  return (
    <IonItem>
      <IonLabel text-wrap>
        <IonText>
          <IonLabel>{title}</IonLabel>
        </IonText>
        {(() => {
          switch (franchisesSyncLoading) {
            case false:
              return (
                <IonText color="medium">
                  Last sync - <span>{franchiseTimestamp} minutes</span>
                </IonText>
              );
            case true:
              return <IonText>Last sync - synchronising...</IonText>;
          }
        })()}
      </IonLabel>
      {enableOfflineMode && (
        <IonButton slot="end" color="primary" disabled={franchisesSyncLoading} onClick={() => handleRefreshButtonClick()}>
          {(() => {
            switch (franchisesSyncLoading) {
              case false:
                return <IonIcon icon={refresh} color="secondary" />;
              case true:
                return <IonSpinner name="lines-small" color="secondary"></IonSpinner>;
            }
          })()}
        </IonButton>
      )}
    </IonItem>
  );
};

export default FranchisesSyncItem;
